import styled from "styled-components"

const Navigation = styled.ul<{ padding?: boolean }>`
  list-style: none;
  padding: ${props => (props.padding ? "0 0 4px 0" : "0")};
  margin-bottom: 8px;
`

export default Navigation
